export default {
  pt: {
    'ordemCarregamento.botao': 'Ordem de Carregamento',
    'ordemCarregamento.titulo': 'Ordem de Carregamento',
    'ordemCarregamento.escolhaDica': 'Escolha a viagem. As viagens aparecem da mais recente para a mais antiga.',
    'ordemCarregamento.viagens': 'Viagens do módulo',
    'ordemCarregamento.buscaMotorista': 'Motorista',
    'ordemCarregamento.buscaPlaca': 'Placa',
    'ordemCarregamento.semViagens': 'Nenhuma viagem com esta busca.',
    'ordemCarregamento.data': 'Data',
    'ordemCarregamento.semData': 'Sem data',
    'ordemCarregamento.motorista': 'Motorista e placas',
    'ordemCarregamento.semMotorista': 'Sem motorista',
    'ordemCarregamento.cliente': 'Cliente',
    'ordemCarregamento.semCliente': 'Sem cliente',
    'ordemCarregamento.trajeto': 'Origem e destino',
    'ordemCarregamento.semLocal': 'Sem local',
    'ordemCarregamento.gerar': 'Gerar Ordem de Carregamento',
    'ordemCarregamento.trocarViagem': 'Trocar a viagem',
    'ordemCarregamento.daViagem': 'Da viagem e do cadastro',
    'ordemCarregamento.previaAlt': 'Prévia da Ordem de Carregamento',
    'ordemCarregamento.copiarImagem': 'Copiar imagem',
    'ordemCarregamento.gerarImagem': 'Gerar imagem',
    'ordemCarregamento.gerarPdf': 'Gerar PDF',
    'ordemCarregamento.copiada': 'Imagem da ordem copiada.',
    'ordemCarregamento.copiaFalhou': 'Não foi possível copiar a imagem. Use Gerar imagem.',
    'ordemCarregamento.copiaNaoSuportada': 'Este navegador não copia imagens. Use Gerar imagem.',
    'ordemCarregamento.gerarFalhou': 'Não foi possível gerar o arquivo. Tente novamente.',
    'ordemCarregamento.campo.base': 'Base',
    'ordemCarregamento.campo.via': 'Número da via',
    'ordemCarregamento.campo.emissao': 'Emissão',
    'ordemCarregamento.campo.hora': 'Hora',
    'ordemCarregamento.campo.cliente': 'Cliente',
    'ordemCarregamento.campo.cnpjTransportador': 'CNPJ do transportador',
    'ordemCarregamento.campo.transportador': 'Transportador',
    'ordemCarregamento.campo.telefone': 'Telefone',
    'ordemCarregamento.campo.contato': 'Contato',
    'ordemCarregamento.campo.motorista': 'Motorista',
    'ordemCarregamento.campo.cpf': 'CPF',
    'ordemCarregamento.campo.placaCavalo': 'Placa do cavalo',
    'ordemCarregamento.campo.placaCarreta': 'Placa da carreta',
    'ordemCarregamento.campo.capacidade': 'Capacidade',
    'ordemCarregamento.campo.material': 'Material',
    'ordemCarregamento.campo.lote': 'Lote ou O.S.',
    'ordemCarregamento.campo.dtShip': 'DT ou Ship',
    'ordemCarregamento.campo.localDescarga': 'Local de descarga',
    'ordemCarregamento.campo.previsao': 'Previsão de entrega ou descarga',
    'ordemCarregamento.campo.observacao': 'Observação',
  },
  en: {
    'ordemCarregamento.botao': 'Loading order',
    'ordemCarregamento.titulo': 'Loading order',
    'ordemCarregamento.escolhaDica': 'Choose the trip. Trips are listed from the most recent to the oldest.',
    'ordemCarregamento.viagens': 'Trips in this module',
    'ordemCarregamento.buscaMotorista': 'Driver',
    'ordemCarregamento.buscaPlaca': 'Plate',
    'ordemCarregamento.semViagens': 'No trips for this search.',
    'ordemCarregamento.data': 'Date',
    'ordemCarregamento.semData': 'No date',
    'ordemCarregamento.motorista': 'Driver and plates',
    'ordemCarregamento.semMotorista': 'No driver',
    'ordemCarregamento.cliente': 'Customer',
    'ordemCarregamento.semCliente': 'No customer',
    'ordemCarregamento.trajeto': 'Origin and destination',
    'ordemCarregamento.semLocal': 'No location',
    'ordemCarregamento.gerar': 'Generate loading order',
    'ordemCarregamento.trocarViagem': 'Change trip',
    'ordemCarregamento.daViagem': 'From the trip and the records',
    'ordemCarregamento.previaAlt': 'Loading order preview',
    'ordemCarregamento.copiarImagem': 'Copy image',
    'ordemCarregamento.gerarImagem': 'Generate image',
    'ordemCarregamento.gerarPdf': 'Generate PDF',
    'ordemCarregamento.copiada': 'Loading order image copied.',
    'ordemCarregamento.copiaFalhou': 'Could not copy the image. Use Generate image.',
    'ordemCarregamento.copiaNaoSuportada': 'This browser cannot copy images. Use Generate image.',
    'ordemCarregamento.gerarFalhou': 'Could not generate the file. Try again.',
    'ordemCarregamento.campo.base': 'Base',
    'ordemCarregamento.campo.via': 'Copy number',
    'ordemCarregamento.campo.emissao': 'Issue date',
    'ordemCarregamento.campo.hora': 'Time',
    'ordemCarregamento.campo.cliente': 'Customer',
    'ordemCarregamento.campo.cnpjTransportador': 'Carrier CNPJ',
    'ordemCarregamento.campo.transportador': 'Carrier',
    'ordemCarregamento.campo.telefone': 'Phone',
    'ordemCarregamento.campo.contato': 'Contact',
    'ordemCarregamento.campo.motorista': 'Driver',
    'ordemCarregamento.campo.cpf': 'CPF',
    'ordemCarregamento.campo.placaCavalo': 'Truck plate',
    'ordemCarregamento.campo.placaCarreta': 'Trailer plate',
    'ordemCarregamento.campo.capacidade': 'Capacity',
    'ordemCarregamento.campo.material': 'Material',
    'ordemCarregamento.campo.lote': 'Lot or W.O.',
    'ordemCarregamento.campo.dtShip': 'DT or Ship',
    'ordemCarregamento.campo.localDescarga': 'Unloading location',
    'ordemCarregamento.campo.previsao': 'Expected delivery or unloading',
    'ordemCarregamento.campo.observacao': 'Notes',
  },
  es: {
    'ordemCarregamento.botao': 'Orden de carga',
    'ordemCarregamento.titulo': 'Orden de carga',
    'ordemCarregamento.escolhaDica': 'Elija el viaje. Los viajes aparecen del más reciente al más antiguo.',
    'ordemCarregamento.viagens': 'Viajes del módulo',
    'ordemCarregamento.buscaMotorista': 'Conductor',
    'ordemCarregamento.buscaPlaca': 'Placa',
    'ordemCarregamento.semViagens': 'Ningún viaje con esta búsqueda.',
    'ordemCarregamento.data': 'Fecha',
    'ordemCarregamento.semData': 'Sin fecha',
    'ordemCarregamento.motorista': 'Conductor y placas',
    'ordemCarregamento.semMotorista': 'Sin conductor',
    'ordemCarregamento.cliente': 'Cliente',
    'ordemCarregamento.semCliente': 'Sin cliente',
    'ordemCarregamento.trajeto': 'Origen y destino',
    'ordemCarregamento.semLocal': 'Sin lugar',
    'ordemCarregamento.gerar': 'Generar orden de carga',
    'ordemCarregamento.trocarViagem': 'Cambiar el viaje',
    'ordemCarregamento.daViagem': 'Del viaje y del registro',
    'ordemCarregamento.previaAlt': 'Vista previa de la orden de carga',
    'ordemCarregamento.copiarImagem': 'Copiar imagen',
    'ordemCarregamento.gerarImagem': 'Generar imagen',
    'ordemCarregamento.gerarPdf': 'Generar PDF',
    'ordemCarregamento.copiada': 'Imagen de la orden copiada.',
    'ordemCarregamento.copiaFalhou': 'No fue posible copiar la imagen. Use Generar imagen.',
    'ordemCarregamento.copiaNaoSuportada': 'Este navegador no copia imágenes. Use Generar imagen.',
    'ordemCarregamento.gerarFalhou': 'No fue posible generar el archivo. Intente de nuevo.',
    'ordemCarregamento.campo.base': 'Base',
    'ordemCarregamento.campo.via': 'Número de copia',
    'ordemCarregamento.campo.emissao': 'Emisión',
    'ordemCarregamento.campo.hora': 'Hora',
    'ordemCarregamento.campo.cliente': 'Cliente',
    'ordemCarregamento.campo.cnpjTransportador': 'CNPJ del transportista',
    'ordemCarregamento.campo.transportador': 'Transportista',
    'ordemCarregamento.campo.telefone': 'Teléfono',
    'ordemCarregamento.campo.contato': 'Contacto',
    'ordemCarregamento.campo.motorista': 'Conductor',
    'ordemCarregamento.campo.cpf': 'CPF',
    'ordemCarregamento.campo.placaCavalo': 'Placa del tractor',
    'ordemCarregamento.campo.placaCarreta': 'Placa del remolque',
    'ordemCarregamento.campo.capacidade': 'Capacidad',
    'ordemCarregamento.campo.material': 'Material',
    'ordemCarregamento.campo.lote': 'Lote u O.S.',
    'ordemCarregamento.campo.dtShip': 'DT o Ship',
    'ordemCarregamento.campo.localDescarga': 'Lugar de descarga',
    'ordemCarregamento.campo.previsao': 'Previsión de entrega o descarga',
    'ordemCarregamento.campo.observacao': 'Observación',
  },
}
